"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
var react_1 = __importStar(require("react"));
var LabelContext_1 = require("../labels/LabelContext");
var GroupContext_1 = require("../layout/GroupContext");
var classnames_1 = __importDefault(require("classnames"));
var react_select_1 = __importDefault(require("react-select"));
var PickerStyles_1 = require("../pickers/PickerStyles");
var MultiSelect = function (props) {
    var onChange = function (v) {
        props.onChange(v);
    };
    var labelCtx = (0, react_1.useContext)(LabelContext_1.LabelContext);
    var groupCtx = (0, react_1.useContext)(GroupContext_1.GroupContext);
    var state = labelCtx.state || props.state;
    return (react_1.default.createElement(react_select_1.default, { isMulti: true, id: props.id || labelCtx.id, name: props.name, options: props.options, value: props.value || [], styles: (0, PickerStyles_1.reactSelectStyles)(state), className: (0, classnames_1.default)(groupCtx.className, props.className), placeholder: props.placeholder, onChange: onChange, isDisabled: props.disabled, "aria-labelledby": props.describedBy || labelCtx.describedBy }));
};
exports.MultiSelect = MultiSelect;
//# sourceMappingURL=MultiSelect.js.map